import * as React from 'react';

// The app icon (src/brand/favicon.svg) as a component: one ribbon dividing
// into two half-width ones, the way a charge splits across transactions.
const UPPER =
  'M18 50H3A15 15 0 0 1 18 35H38C62 35 60 14 84 14A7.5 7.5 0 0 1 84 29C70 29 66 50 38 50Z';
const LOWER =
  'M18 50H38C66 50 70 71 84 71A7.5 7.5 0 0 1 84 86C60 86 62 65 38 65H18A15 15 0 0 1 3 50Z';

type Props = {
  className?: string;
};

export const BrandMark = ({className}: Props) => {
  // Gradient ids are document-global, so each instance needs its own.
  const id = React.useId();
  const tile = `${id}-tile`;
  const glow = `${id}-glow`;
  const upper = `${id}-upper`;
  const lower = `${id}-lower`;

  return (
    <svg viewBox="0 0 100 100" className={className} aria-hidden>
      <defs>
        <linearGradient id={tile} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#5a98f5" />
          <stop offset="1" stopColor="#1f4fae" />
        </linearGradient>
        <radialGradient id={glow} cx=".22" cy=".12" r=".9">
          <stop offset="0" stopColor="#fff" stopOpacity=".28" />
          <stop offset=".6" stopColor="#fff" stopOpacity="0" />
        </radialGradient>
        <linearGradient id={upper} x1="0" y1="0" x2="1" y2="0">
          <stop offset="0" stopColor="#fff" />
          <stop offset="1" stopColor="#eef4ff" />
        </linearGradient>
        <linearGradient id={lower} x1="0" y1="0" x2="1" y2="0">
          <stop offset="0" stopColor="#d5e4fd" />
          <stop offset="1" stopColor="#a9c7f8" />
        </linearGradient>
      </defs>
      <rect width="100" height="100" rx="22" fill={`url(#${tile})`} />
      <rect width="100" height="100" rx="22" fill={`url(#${glow})`} />
      <g transform="translate(12.2 10) scale(0.8)">
        <path d={LOWER} fill={`url(#${lower})`} />
        <path d={UPPER} fill={`url(#${upper})`} />
      </g>
    </svg>
  );
};
